/**
 * Created by slava on 30/8/17
 */

const Friends = function () {
    this.data = {};
    this.lastUpdateTime = 0;

    this.load();
};

Friends.prototype.reset = function () {
    this.data = {};
    this.lastUpdateTime = 0;
    this.save();
};

Friends.prototype.load = function () {
    const stored = cleverapps.dataLoader.load(DataLoader.TYPES.FRIENDS);
    if (stored) {
        this.data = stored.data;
        this.lastUpdateTime = stored.when;
    }

    for (const id in this.data) {
        const friend = this.data[id];
        if (friend.inApp === undefined) {
            friend.inApp = true;
        }
    }
};

Friends.prototype.save = function () {
    const info = {
        data: this.data,
        when: this.lastUpdateTime
    };
    cleverapps.dataLoader.save(DataLoader.TYPES.FRIENDS, info);
};

Friends.prototype.setData = function (friends) {
    // console.log("Loaded new friends list: ", friends);

    this.data = {};
    friends.forEach((friend) => {
        this.data[friend.id] = {
            id: friend.id,
            name: friend.firstName || friend.name,
            avatar: friend.avatar,
            invitable: friend.invitable
        };
    });

    this.lastUpdateTime = Date.now();
    this.save();
};

Friends.prototype.getById = function (id) {
    return this.data[id];
};

Friends.prototype.listIds = function () {
    return Object.keys(this.data);
};

Friends.prototype.listInAppIds = function () {
    return Object.keys(this.data).filter((id) => this.data[id].inApp);
};

Friends.prototype.listFriends = function () {
    return Object.values(this.data);
};

Friends.prototype.listInAppFriends = function () {
    return Object.values(this.data).filter((friend) => friend.inApp);
};

Friends.prototype.needReload = function () {
    return this.listIds().length === 0 || this.lastUpdateTime + Friends.RELOAD_INTERVAL < Date.now();
};

Friends.prototype.reload = function (callback) {
    let friends;
    let invitableFriends;

    new ActionPlayer([
        function (f) {
            connector.social.listFriends((code, list) => {
                if (code === cleverapps.CODE_SUCCEED) {
                    friends = list;
                }

                f();
            });
        },

        function (f) {
            connector.social.listInvitableFriends((code, list) => {
                if (code === cleverapps.CODE_SUCCEED) {
                    invitableFriends = list;
                }

                f();
            });
        }
    ]).play(() => {
        if (friends || invitableFriends) {
            this.setData((friends || []).concat(invitableFriends || []));
        }

        callback();
    });
};

Friends.loadFriends = function (onSuccess, onFailure) {
    cleverapps.focusManager.display({
        stack: true,
        focus: "LoadFriends",
        action: (f) => {
            const player = new ActionPlayer([
                (f, stop) => {
                    cleverapps.SocialManager.enforceLogin(
                        (code) => {
                            if (code === cleverapps.CODE_SUCCEED) {
                                f();
                            } else {
                                stop();
                            }
                        },
                        { signInWindow: "viral" }
                    );
                },

                (f) => {
                    cleverapps.loading.show();
                    f();
                },

                (f) => {
                    connector.social.askFriendsPermission(cleverapps.waitNoMore(cleverapps.parseInterval("10 seconds"), f));
                },

                (f) => {
                    if (cleverapps.friends.needReload()) {
                        cleverapps.friends.reload(f);
                    } else {
                        f();
                    }
                },

                (f) => {
                    cleverapps.loading.hide();
                    f();
                }
            ]);

            player.onComplete(f);
            player.onSuccess(onSuccess);
            player.onFailure(onFailure);

            player.play();
        }
    });
};

Friends.RELOAD_INTERVAL = cleverapps.parseInterval("7 days");